/**
 * @typedef Profile
 * @property {string} avatar_url
 * @property {string} name
 * @property {string} last_seen_at
 */

/**
 *
 * @param organization
 * @param {string} userInternalId
 * @returns {null|Profile}
 */
export const getProfile = (organization, userInternalId) => {
  if (organization.loading) return null;
  // noinspection JSUnresolvedVariable
  const profiles = organization.profiles;
  // noinspection JSUnresolvedVariable
  const profile = profiles.find(p => p.internal_id === userInternalId);
  return profile;
};

export const getUserStatus = (userStatusCtx, internalId) => {
  return userStatusCtx[internalId] || {};
};



// WEBPACK FOOTER //
// ./selectors/index.js